import React, { useState } from "react";
import ImageModal from "./ImageModal";
import ReactDOM from "react-dom";

interface ImageModalTriggerProps {
    url: string;
    altText?: string;
    children?: React.ReactNode;
    showImageIcon?: boolean;
}

const ImageModalTrigger: React.FC<ImageModalTriggerProps> = ({ url, altText, children, showImageIcon = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return (
        <>
            <div onClick={openModal} style={{ cursor: "pointer", position: "relative", width: "100%", height: "100%" }}>
                {showImageIcon &&
                    <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6932fb0178760a42df91b702_picture%20(1).png" loading="lazy" alt="" className="icon-size-24 photo-icon" />
                }
                {children}
            </div>

            {isOpen && ReactDOM.createPortal(
                <ImageModal url={url} altText={altText} onClose={closeModal} />, document.body
            )}
        </>
    );
};

export default ImageModalTrigger;
